import React from "react";
import { connect } from "react-redux";
import { elementActions } from "../../../../../store/actions/cms/element/element.action";
import {
  Button,
  Col,
  FormGroup,
  Input,
  Label,
  Row,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  ButtonGroup
} from "reactstrap";
import { defaultQuestionElement } from "../../../../models/defaultElements";
import SystemLabel from "../../../../../system/SystemLabel/SystemLabel";
import { tempLangConverter } from "../../../../../helpers/lanugageHelper";

class CreateQuestion extends React.Component {
  state = {
    labelSet: false,
    data: {
      editable: false,
      hidden: false,
      style: {},
      validation: {},
      relations: [],
      textRows: 0
    },
    typeIsValid: false,
    labelsIsValid: false,
    formIsValid: false,
    eventId: 0,
    formId: 0,

    props: {
      type: "",
      requiredMin: 0,
      requiredMax: 0,
      labels: [],
      subLabels: [],
      subInputs: [],

      options: []
    }
  };
  componentDidMount() {
    const { formId, eventId } = this.props.form;
    this.setState({ eventId, formId });
  }
  handleChange(e, path) {
    const names = path.split(".");
    const state = { ...this.state };

    let value = null;

    if (path === 'props.requiredMin') {
      value = e;
    }
    else {
      value = e.target.value;
    }
    if (names[1] === "labels") {
      state[names[0]][names[1]][names[2]][names[3]] = value;
      if (state.props.labels.length > 0 && !state.props.labels.find(l => l.text === '')) {
        state.labelsIsValid = true;
      }

      this.setState(state);
    } else {
      state[names[0]][names[1]] = value;
      this.setState(state);
    }
  }
  create = () => {
    const { formId, eventId, languageCode } = this.props.form;
    const { dispatch, event, action2 } = this.props;
    let el = {
      ...defaultQuestionElement,
      formId: formId,
      eventId: eventId,
      languageCode: languageCode,
      props: { ...this.state.props },
      data: defaultQuestionElement.data
    };
    dispatch(elementActions.create(el, event.eventLanguage));
    action2();
  };
  componentDidUpdate() {
    if (this.state.props.labels.length < 1 && this.state.labelSet === false && this.props.language && this.props.language.eventCodes) {

      const { eventCodes } = this.props.language;
      const { isOpen } = this.props;
      const state = { ...this.state };

      state.modal = isOpen;
      if (eventCodes) {
        for (let i = 0; i < eventCodes.length; i++) {
          state.props.labels.push({
            text: "",
            languageCode: eventCodes[i].code,
            isValid: false
          });
          state.props.subLabels.push({
            text: "",
            languageCode: eventCodes[i].code,
            isValid: false
          });
          state.props.subInputs.push({
            text: "",
            languageCode: eventCodes[i].code,
            isValid: false
          });
        }
        state.labelSet = true;
      }
      this.setState(state);
    }
  }
  setQuestionType = (type) => {
    const state = { ...this.state };
    state.props.type = type;
    state.typeIsValid = true;
    state.props.name = "";
    this.setState(state, () => {
      this.validateForm();
    });

  }
  validateForm = () => {
    const {
      typeIsValid,
      labelsIsValid
    } = this.state;
    this.setState({
      formIsValid: typeIsValid
    });
  };

  render() {
    const { title, actionLabel, action2 } = this.props;
    const { props, data } = this.state;
    const { eventCodes } = this.props.language;
    return (
      <div>
        <Modal
          isOpen={this.props.isOpen}
          toggle={action2}
          className={this.props.className}
        >
          <ModalHeader toggle={this.toggle}><SystemLabel name="CreateNewQuestion" /></ModalHeader>
          <ModalBody>
            <div>
              <Row>
                <Col xs="12">
                  <FormGroup>
                    <Label htmlFor="label"><SystemLabel name="QuestionNames" /></Label>
                    {eventCodes.length > 0 &&
                      eventCodes.map((c, index) => {
                        return (
                          <React.Fragment key={index}>
                            <InputGroup className="mb-3">
                              <InputGroupAddon addonType="prepend">
                                <InputGroupText style={{ border: 0, backgroundColor: 'none' }}>
                                  <i className={`flag-icon flag-icon-${tempLangConverter(c.code)}`} />
                                </InputGroupText>
                              </InputGroupAddon>
                              <Input
                                autoComplete="jirango-nofill"
                                type="text"
                                id="name"
                                onChange={e =>
                                  this.handleChange(
                                    e,
                                    `props.labels.${index}.text`
                                  )
                                }
                              />
                            </InputGroup>
                          </React.Fragment>
                        );
                      })}
                  </FormGroup>
                </Col>
              </Row>
              <hr />
              <Row>
                <FormGroup>
                  <Col xs="6">
                    <FormGroup>
                      <ButtonGroup>
                        <Button onClick={() => this.setQuestionType("Text")}
                          color={props.type === "Text" ? "success" : "secondary"}>
                          <SystemLabel name="Text" />
                        </Button>
                        <Button onClick={() => this.setQuestionType("Option")}
                          color={props.type === "Option" ? "success" : "secondary"}>
                          <SystemLabel name="Option" />
                        </Button>
                      </ButtonGroup>
                    </FormGroup>
                  </Col>
                </FormGroup>
              </Row>
            </div>
          </ModalBody>
          <ModalFooter>
            <Button color="primary" onClick={this.create}>
              <SystemLabel name="Create" />
            </Button>{" "}
            <Button color="secondary" onClick={action2}>
              <SystemLabel name="Cancel" />
            </Button>
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    form: state.form,
    event: state.event,
    language: state.language
  };
}

export default connect(mapStateToProps)(CreateQuestion);
